import http from 'utils/http'

const sendEmailToRegisterCompany = payload => http.post('/settings/v1/settings/sendmailcompany', payload)

const sendEmailContact = payload => http.post('/settings/v1/settings/sendmailcontact', payload)

export default {
  sendEmailToRegisterCompany,
  sendEmailContact
}



// WEBPACK FOOTER //
// ./src/services/landingService.js